import type { TOC } from '@ember/component/template-only'
import { LinkTo } from '@ember/routing'
import { t } from 'ember-intl'

interface Signature {
  Element: HTMLDivElement
  Args: {
    activity_id: string
    title: string
    description: string
  }
}
export const LongWritesCatalogueCard: TOC<Signature> = <template>
  <LinkTo @route="subscription-type.long-writes.previews" @model={{@activity_id}}>
    <div class="border-grey-500 text-wl-blue-300 relative h-40 w-64 border p-4">
      <span
        class="bg-juicy-orange-450 absolute -top-4 left-1/2 -translate-x-1/2 rounded-full px-8 py-1 text-sm text-white"
      >
        {{t "pages.longWrites.activityTypes.persuasive"}}
      </span>
      <h2 class="text-lg font-semibold">{{@title}}</h2>
      <p class="mt-2">
        {{@description}}
      </p>
    </div>
  </LinkTo>
</template>
